import { Flex, Button, Heading, useColorModeValue } from '@chakra-ui/react';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';

interface CalendarNavigationProps {
  headerText: string;
  onPrevious: () => void;
  onNext: () => void;
  onToday: () => void;
}

/**
 * Calendar Navigation Component
 * Contains previous/next buttons, current date display, and "Today" button
 */
export function CalendarNavigation({
  headerText,
  onPrevious,
  onNext,
  onToday,
}: CalendarNavigationProps) {
  const buttonBg = useColorModeValue('white', 'gray.700');
  const buttonHoverBg = useColorModeValue('gray.50', 'gray.600');
  const todayButtonBg = useColorModeValue('blue.600', 'blue.500');
  const todayButtonHoverBg = useColorModeValue('blue.700', 'blue.600');
  const borderColor = useColorModeValue('gray.300', 'gray.600');

  return (
    <Flex justify="space-between" align="center" mb={4}>
      <Button
        onClick={onPrevious}
        bg={buttonBg}
        borderColor={borderColor}
        _hover={{ bg: buttonHoverBg }}
        aria-label="Previous"
      >
        <ChevronLeftIcon />
      </Button>

      <Flex align="center" gap={4}>
        <Heading size="md">{headerText}</Heading>
        <Button
          onClick={onToday}
          size="sm"
          bg={todayButtonBg}
          color="white"
          _hover={{ bg: todayButtonHoverBg }}
        >
          Today
        </Button>
      </Flex>

      <Button
        onClick={onNext}
        bg={buttonBg}
        borderColor={borderColor}
        _hover={{ bg: buttonHoverBg }}
        aria-label="Next"
      >
        <ChevronRightIcon />
      </Button>
    </Flex>
  );
}

